import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { B2BUnit, EventService, OccEndpointsService } from '@spartacus/core';
import { map, tap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { UserAccountChangedEvent } from '@spartacus/user/account/root';
import { CartActions } from '../features/cart/core/store';
import { GenSpecialProgram } from '../models/special-program.model';

@Injectable({
  providedIn: 'root',
})
export class GenCustomerService {
  private currentB2bUnit$: BehaviorSubject<string> = new BehaviorSubject('');
  private b2bUnitChanged$: BehaviorSubject<boolean> = new BehaviorSubject(
    false
  );
  private specialPrograms$: BehaviorSubject<GenSpecialProgram[]> = new BehaviorSubject<GenSpecialProgram[]>([]);

  constructor(
    private httpClient: HttpClient,
    protected store: Store,
    protected eventService: EventService,
    private occEndpoints: OccEndpointsService,
  ) { }

  public getB2BUnits(): Observable<B2BUnit[]> {
    const url = `${this.occEndpoints.getBaseUrl()}/B2BUnits`;
    return this.httpClient
      .get(url)
      .pipe(
        tap((val: { b2BUnit?: B2BUnit[] }) => {
          this.specialPrograms$.next(
            this.findSpecialProgramsForUnit(val?.b2BUnit, localStorage.getItem('companyNumber') || '')
          );
        }),
        map((val: { b2BUnit?: B2BUnit[] }) => val?.b2BUnit));
  }

  public setB2BUnit(unitId: string, userId: string): Observable<any> {
    localStorage.setItem('companyNumber', unitId);
    this.setCurrentB2bUnit(unitId);
    const url = `${this.occEndpoints.getBaseUrl()}/users/${userId}/B2BUnits/unit/${unitId}`;
    return this.httpClient.post(url, {}).pipe(
      tap(() => {
        this.eventService.dispatch({ user: {} }, UserAccountChangedEvent);
        this.store.dispatch(new CartActions.ClearCartState());
        this.b2bUnitChanged$.next(true);
      })
    );
  }

  public getB2bUnitChanged(): Observable<boolean> {
    return this.b2bUnitChanged$.asObservable();
  }

  public getCurrentB2bUnit(): Observable<string> {
    return this.currentB2bUnit$.asObservable()
      .pipe(map(unit => unit || localStorage.getItem('companyNumber')));
  }

  public setCurrentB2bUnit(unitId: string): void {
    this.currentB2bUnit$.next(unitId);
    localStorage.setItem('B2BChanged', 'true');
  }

  public getSpecialPrograms(): Observable<GenSpecialProgram[]> {
    return this.specialPrograms$.asObservable();
  }

  public setSpecialProgram(userId: string, specialProgramId: string): Observable<any> {
    return this.httpClient.post(
      `${this.occEndpoints.getBaseUrl()}/users/${userId}/specialProgram/${specialProgramId}`, {}
    ).pipe(
      tap(() => {
        localStorage.setItem('specialProgram', specialProgramId);
        this.store.dispatch(new CartActions.ClearCartState());
        this.b2bUnitChanged$.next(true); // emiting the same behaviour as for unit change to refresh the page
      })
    );
  }

  private findSpecialProgramsForUnit(b2bUnits: B2BUnit[], untiId: string): GenSpecialProgram[] {
    const unit = b2bUnits.find((unit) => unit.partnerId === untiId);
    return unit?.specialPrograms || [];
  }
}
